import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import Button from 'Components/Atoms/Button/Button';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import Table from 'Components/Molecules/Table/Table';
import TableBody from 'Components/Molecules/TableBody/TableBody';
import TableCell from 'Components/Molecules/TableCell/TableCell';
import TableColumn from 'Components/Molecules/TableColumn/TableColumn';
import TableHeader from 'Components/Molecules/TableHeader/TableHeader';
import TableRow from 'Components/Molecules/TableRow/TableRow';
import React, { Suspense, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { createContactModule, fetchContactModules } from 'Store/Modules/ContactModule/Actions';
import { getContactByEntityId, getContactByIdAsObject, isContactCreating, isContactLoading } from 'Store/Modules/ContactModule/Selectors';
import { StoreState } from 'Store/Reducers';
import { getEntitiesById, getEntityById } from 'Store/Settings/Entities/Selectors';
import { fetchModules } from 'Store/Settings/Modules/Actions';
import { getModulesByEntityIdByModule } from 'Store/Settings/Modules/Selectors';
import ContactItem from './ContactItem/ContactItem';

const ContactCreate = React.lazy(() => import('./ContactCreate/ContactCreate'));

const Contact = ({
    id, entity_id, isEdit,

    entity, 
    modulesByEntityIdByModule, entityById, contact_methods, contactById,
    
    isLoading, isCreating,
    ...props
}: ContactProps) => {
    const [state, setState] = useState({
        isOpen: false,
        isEdit: isEdit ?? true
    });

    useEffect(() => {
        props.fetchModules();
        props.fetchContactModules(id);
    }, []);

    const handleNewModal = () => setState((state) => ({
        ...state,
        isOpen: !state.isOpen
    }));

    return <>
        <Suspense>
            {
                state.isOpen
                && <ContactCreate
                    record_id={id}
                    entity_id={entity_id}
                    onClose={handleNewModal}
                />
            }
        </Suspense>
        <Table>
            <TableHeader>
                <TableColumn>Naam</TableColumn>
                <TableColumn>Type</TableColumn>
                <TableColumn>Is primair?</TableColumn>
                {
                    entity.name === 'business_unit'
                    && <TableColumn>Afdeling</TableColumn>
                }
                {
                    entity.name === 'contact'
                    && <TableColumn>Relatie</TableColumn>
                }
            </TableHeader>
            <TableBody>
                {
                    state.isEdit
                    && <TableRow>
                        <TableCell>
                            <Button
                                size='inline'
                                iconBefore={<FontAwesomeIcon icon={faPlus} />}
                                onClick={handleNewModal}
                                >
                                Toevoegen
                            </Button>
                        </TableCell>
                    </TableRow>
                }
                {
                    contact_methods
                    ?.map(contactId => {
                        return <ContactItem
                            key={contactId.id}
                            id={contactId.id}
                            record_id={id}
                            entity_id={entity_id}
                            isEdit={isEdit}
                        />;
                    })
                }
            </TableBody>
        </Table>
    </>;
}

interface Props {
    id: string
    entity_id: any
    isEdit?: boolean
};

const mapState = (state: StoreState, props: Props) => ({
    modulesByEntityIdByModule: getModulesByEntityIdByModule(state),
    entityById: getEntitiesById(state),

    contact_methods: getContactByEntityId(state, props.id),
    contactById: getContactByIdAsObject(state),

    entity: getEntityById(state, props.entity_id),

    isLoading: isContactLoading(state),
    isCreating: isContactCreating(state)
});

const mapDispatch = {
    fetchModules,
    fetchContactModules,
    createContactModule
};

type ContactProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(Contact);